import { RootStateOrAny, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { FormsState } from './formsReducer';

export const selectForms = ({ forms }: RootStateOrAny): FormsState => forms;

export const makeSelectFormState = (stateId: string) =>
  createSelector(selectForms, (forms: FormsState) => forms[stateId]);

export const useFormState = (stateId: string) => useSelector(makeSelectFormState(stateId));
